import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Stats.css';

const Stats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await api.getStats();
        setStats(data);
      } catch (err) {
        setError('Failed to load stats: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <div className="loading">Loading statistics...</div>;
  if (error) return <div className="error">{error}</div>;

  const maxCount = Math.max(...stats.top_reaction_types.map(t => t.count));

  return (
    <div className="stats-container">
      <div className="stats-header">
        <h1>Database Statistics</h1>
        <p className="subtitle">Overview of the chemical reactions collection</p>
      </div>

      <div className="stats-cards">
        <div className="stat-card">
          <div className="stat-number">{stats.total_reactions.toLocaleString()}</div>
          <div className="stat-label">Total Reactions</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{stats.total_molecules.toLocaleString()}</div>
          <div className="stat-label">Total Molecules</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{stats.top_reaction_types.length}</div>
          <div className="stat-label">Reaction Types (Top)</div>
        </div>
      </div>

      <div className="top-types-section">
        <h2>Top Reaction Types</h2>
        <div className="bar-chart">
          {stats.top_reaction_types.map((type, i) => (
            <div key={i} className="bar-row">
              <div className="bar-label">{type.reaction_type}</div>
              <div className="bar-track">
                <div
                  className="bar-fill"
                  style={{ width: `${(type.count / maxCount) * 100}%` }}
                />
                <span className="bar-count">{type.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stats;
